import {useMutation} from "@tanstack/react-query";
import client from '../../utils/Client'




// UPDATE A FORM
const submit = (payload) => client.put('forms/types', payload);
export const useUpdateForm = (id) => useMutation(['updateForm',id],(payload) => submit(payload))


// Disengage A FORM
const disEngage = (payload) => client.put(`forms/disengage/${payload?.formId}/${payload?.officerId}`);
export const useDisEngageForm = (payload) => useMutation(['disengageForm',payload?.formId],(payload) => disEngage(payload))


// POST TO OFFICIAL INFO
const officialInfoSubmit = (formId,payload) => client.post(`forms/${formId}/officialInfo`, payload);
export const useSubmitOfficialInfo = (formId) => useMutation(['createForm',formId],(payload) => officialInfoSubmit(formId,payload))

// Complete A FORM
const completeFormAction = (payload)  => client.put(`forms/complete/${payload.formId}/${payload.officerId}`);
export const useCompleteFormAction = (formId) => useMutation(['completeForm',formId],(payload) => completeFormAction(payload))


// MOVE A FORM TO ONLY ROLE
const moveFormActionToRole = (payload)  => client.put(`forms/moveToDesk/${payload.formId}/${Number(payload.roleId)}`);
export const useMoveFormActionToRole = (formId) => useMutation(['moveFormToRole',formId],(payload) => moveFormActionToRole(payload))

// MOVE A FORM TO  ROLE  & BRANCH
const moveFormActionToRoleAndBranch = (payload)  => client.put(`forms/moveToBranch/${payload.formId}/${Number(payload.branchId)}/${Number(payload.roleId)}`);
export const useMoveFormActionToRoleAndBranch = (formId) => useMutation(['moveFormToRoleAndBranch',formId],(payload) => moveFormActionToRoleAndBranch(payload))


